import { defineMessage } from '../../../../services/localization';

export const messages = {
    defaultPlaceholder: defineMessage('enter_text'),
    defaultEmptyListPlaceholder: defineMessage('empty'),
    defaultEmptyAddNew: defineMessage('add'),
    defaultAddNew: defineMessage('add_text'),
    suggestedItemText: defineMessage('suggested'),
};
